import { render } from "./BGZG18.vue?vue&type=template&id=128647c4&scoped=true"
import script from "./BGZG18.vue?vue&type=script&lang=js"
export * from "./BGZG18.vue?vue&type=script&lang=js"

import "./BGZG18.vue?vue&type=style&index=0&id=128647c4&lang=css"
import "./BGZG18.vue?vue&type=style&index=1&id=128647c4&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128647c4"]])

export default __exports__